// extracted by mini-css-extract-plugin
module.exports = {"overflowingText":"OverflowingText-overflowingText-1HeCOD"};